﻿import { ValgStateActionTypes, ValgState, TOGGLE_VILKAR, UPDATE_VALG, TOGGLE_UTBETALING } from './Types';

export const initialState: ValgState = {
    aUtdanningsValg: undefined,
    bStudieforberedende: undefined,
    bYrkesfag: undefined,
    visVilkar: false,
    visUtbetaling: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aUtdanningsValg) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            case TOGGLE_UTBETALING: {
                return {
                    ...state,
                    visUtbetaling: !state.visUtbetaling,
                };
            }
            default:
                return state;
        }
    }
}
